@if(displayFakeDate){
  <p>Simulerat dagens datum {{sxFakeDate }}</p>
}

@if(!isLoading){
  <div class="sx-disruption__pane">
    
    <!-- Leveransstörning -->
     @if(displayDeliveryDisruptions){
      
      <app-system-message 
        [isVisible]="true" 
        [isDismissable]="false" 
        [severity]="2" 
        [icon]="'#sx-varning'"
        [type]="3">
        
        @if(isStartPageView){
          <a href="#" [routerLink]="['/secure/meteringpoints/disruptions']" class="sx-disruption__link">
            {{deliveryDisruptions}}
            {{ (deliveryDisruptions === 1 ? 'disruptions.link_message_single' : 'disruptions.link_message') | translate}}
          </a>
        }
        @if(restoreTimeFormated){
          {{ selectedMeteringPointDisruption ? (('disruptions.ongoing-delivery-disruption' | translate)  + '. ' + ('disruptions.restore_time' | translate) + restoreTimeFormated) : ('disruptions.delivery_disruption_message' | translate) }} 
        }
        @else {
          {{ selectedMeteringPointDisruption ? (('disruptions.ongoing-delivery-disruption' | translate) + '. ' + ('disruptions.restore_information_label_short_not_set' | translate)) : ('disruptions.delivery_disruption_message' | translate) }} 
        }
      </app-system-message>
     }


    <!-- Planerat avbrott -->
     @if(displayPlanneDisruptions){
      <app-system-message 
        [isVisible]="true" 
        [isDismissable]="false" 
        [severity]="2" 
        [icon]="'#sx-varning'"
        [type]="3">

        @if(isStartPageView){
          <a href="#" [routerLink]="['/secure/meteringpoints/disruptions']" class="sx-disruption__link">
            {{plannedDisruptions}}
            {{ (plannedDisruptions === 1 ? 'disruptions.link_message_single' : 'disruptions.link_message') | translate}}
          </a>
        }
        @if(restoreTimeFormated){
          {{ selectedMeteringPointDisruption ? (('disruptions.ongoing-planned-disruption' | translate)  + '. ' + ('disruptions.restore_time' | translate) + restoreTimeFormated) : ('disruptions.planned_message' | translate) }} 
        }
        @else {
          {{ selectedMeteringPointDisruption ? (('disruptions.ongoing-planned-disruption' | translate) + '. ' + ('disruptions.restore_information_label_short_not_set' | translate)) : ('disruptions.planned_message' | translate) }} 
        }
      </app-system-message>
     }

    <!-- Driftstörningar -->
     @if(displayUnplannedDisruptions){
      <app-system-message  
        [isVisible]="true" 
        [isDismissable]="false" 
        [severity]="3" 
        [icon]="'#sx-blocked'"
        [type]="3">
        @if(isStartPageView){
          <a href="#" [routerLink]="['/secure/meteringpoints/disruptions']" class="sx-disruption__link">
            {{unPlannedDisruptions}}
            {{ (unPlannedDisruptions === 1 ? 'disruptions.link_message_single' : 'disruptions.link_message') | translate}}
          </a>
        }
        @if(restoreTimeFormated){
          {{ selectedMeteringPointDisruption ? (('disruptions.ongoing-unplanned-disruption' | translate)  + '. ' + ('disruptions.restore_time' | translate) + restoreTimeFormated) : ('disruptions.unplanned_message' | translate) }}       
        }
        @else {
          {{ selectedMeteringPointDisruption ? (('disruptions.ongoing-unplanned-disruption' | translate)  + '. ' + ('disruptions.restore_information_label_short_not_set' | translate)) : ('disruptions.unplanned_message' | translate) }}       
        }
      </app-system-message>
     }

    <!-- Åtgärdade -->
    @if(displayRestoredDisruptions){
      <app-system-message 
        [isVisible]="true" 
        [isDismissable]="false" 
        [severity]="1" 
        [icon]="'#sx-info'"
        [type]="3">
        @if(isStartPageView){
          <a href="#" [routerLink]="['/secure/meteringpoints/disruptions']" class="sx-disruption__link">
            {{restoredDisruptions}}
            {{ (restoredDisruptions === 1 ? 'disruptions.link_message_single' : 'disruptions.link_message') | translate}}
          </a>
          {{ 'disruptions.restored_message' | translate }} 
        }
        @if(selectedMeteringPointRestoredDisruption){
          @switch (selectedMeteringPointRestoredDisruption.disturbanceType) {
            @case(disturbanceTypeEnum.Planned){
              {{ ('disruptions.restored_planned_message_single' | translate) + (selectedMeteringPointRestoredDisruption.startTime | date: 'HH:mm, d MMMM yyyy') }} 
            }
            @case(disturbanceTypeEnum.Delivery){
              {{ ('disruptions.restored_delivery_message_single' | translate) + (selectedMeteringPointRestoredDisruption.startTime | date: 'HH:mm, d MMMM yyyy') }} 
            }
            @case(disturbanceTypeEnum.Unplanned){
              {{ ('disruptions.restored_unplanned_message_single' | translate) + (selectedMeteringPointRestoredDisruption.startTime | date: 'HH:mm, d MMMM yyyy') }} 
            }
          }
        }
      </app-system-message>
    }
  </div>
}
